/*******************************************************************************
ADJUST ARROWS ON SCROLL
Adjusts the display of the left/right arrows based on scroll position.
*******************************************************************************/

export default function adjustArrows($scrollArea) {
    const $scrollTabsOuter = $scrollArea.parents('.scroll-tabs-outer');

    // The full width of the full scroll tabs nav bar
    const width = parseInt($scrollArea[0].scrollWidth, 10);

    // The width of the visible scrollable area
    const visibleWidth = parseInt($scrollArea.outerWidth(), 10);

    // The left scroll position inside the scrollable area
    const scrollLeft = parseInt($scrollArea.scrollLeft(), 10);

    // Show the right arrow if either of these apply:
    // 1. The table is scrolled all the way over to the right (with a 30px buffer to make things more smooth).
    // 2. The table does not need to be scrolled horizontally (the < 5 is to account for varying pixel calculations by browsers).
    const rightOpacityClass = ((width <= visibleWidth + scrollLeft + 30) || (width - visibleWidth) < 5) ? 'is-hidden' : 'is-visible';
    $scrollTabsOuter.find('.nav-arrow-right').removeClass('is-hidden is-visible').addClass(rightOpacityClass);

    // Show the left arrow if either of these apply:
    // 1. The table is scrolled all the way over to the left (with a 30px buffer to make things more smooth).
    // 2. The table does not need to be scrolled horizontally (the < 5 is to account for varying pixel calculations by browsers).
    const leftOpacityClass = (scrollLeft <= 30 || (width - visibleWidth) < 5) ? 'is-hidden' : 'is-visible';
    $scrollTabsOuter.find('.nav-arrow-left').removeClass('is-hidden is-visible').addClass(leftOpacityClass);
}
